import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import Cookie from "js-cookie";
import { checkEnableMT5 } from "./utils/helper";

Vue.use(Router);

var router = new Router({
  mode: "history",
  base: process.env.VUE_APP_PATH,
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/login",
      component: () => import("@/view/login/Login.vue"),
    },
    {
      path: "/token",
      component: () => import("@/view/module/Token.vue"),
    },
    {
      path: "/forgetPwd",
      component: () => import("@/view/login/ForgetPwd.vue"),
    },
    {
      path: "/forgetPwdAcc",
      component: () => import("@/view/login/ForgetPwdAcc.vue"),
    },
    {
      path: "/setPasswordByEmail",
      component: () => import("@/view/login/SetPasswordByEmail.vue"),
    },
    {
      path: "/addMT5Result",
      component: () => import("@/view/addMT5/AddMT5Result.vue"),
    },
    {
      path: "/home",
      component: () => import("@/view/InitData.vue"),
      meta: {
        userAuth: true,
      },
      children: [
        {
          path: "",
          component: () => import("@/view/home/Index.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "recordDetail",
          name: "recordDetail",
          component: () => import("@/view/record/RecordDetail.vue"),
        },
        {
          path: "personalCenter",
          component: () => import("@/view/home/PersonalCenter.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "accOverview",
          component: () => import("@/view/home/AccOverview.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "addWeChat",
          component: () => import("@/view/home/AccAddWeChat.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "addTelegram",
          component: () => import("@/view/home/AccAddTelegram.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "addX",
          component: () => import("@/view/home/AccAddX.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "accLevel",
          component: () => import("@/view/home/AccLevel.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "accInfo",
          component: () => import("@/view/home/AccInfo.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "accUpgrade",
          component: () => import("@/view/home/AccUpgrade.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "modifyPwd",
          component: () => import("@/view/login/ModifyPwd.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "referral",
          component: () => import("@/view/referral/Referral.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "success",
          component: () => import("@/view/module/Success.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "personalInfo",
          component: () => import("@/view/personalInfo/PersonalInfo.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "credentials",
          component: () => import("@/view/personalInfo/Credentials.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "address",
          component: () => import("@/view/personalInfo/Address.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "identity",
          component: () => import("@/view/personalInfo/Identity.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "faceValidate",
          component: () => import("@/view/personalInfo/FaceValidate.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "addBankCard",
          component: () => import("@/view/bankCard/AddBankCard.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "uploadProof",
          component: () => import("@/view/bankCard/UploadProof.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "bankList",
          component: () => import("@/view/bankCard/BankList.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "addBankBranch",
          component: () => import("@/view/bankCard/AddBankBranch.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "eWalletList",
          component: () => import("@/view/ewallet/EwalletList.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "problem",
          component: () => import("@/view/bankCard/Problem.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "recharge",
          component: () => import("@/view/recharge/Recharge.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "rechargeConfirm",
          component: () => import("@/view/recharge/RechargeConfirm.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "rechargeDictConfirm",
          component: () => import("@/view/recharge/RechargeDictConfirm.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "iviPayMobile",
          component: () => import("@/view/recharge/IviPayMobile.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "rechargeResult",
          component: () => import("@/view/recharge/RechargeResult.vue"),
        },
        {
          path: "rechargeQRCode",
          component: () => import("@/view/recharge/RechargeQRCode.vue"),
        },
        {
          path: "withdrawal",
          component: () => import("@/view/withdrawal/Withdrawal.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "withdrawalConfirm",
          component: () => import("@/view/withdrawal/WithdrawalConfirm.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "withdrawalResult",
          component: () => import("@/view/withdrawal/WithdrawalResult.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "registerUSDT",
          component: () => import("@/view/withdrawal/RegisterUSDT.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "record",
          name: "record",
          component: () => import("@/view/record/Record.vue"),
          meta: {
            userAuth: true,
            keepAlive: true,
          },
        },
        {
          path: "uploadDocuments",
          name: "uploadDocuments",
          component: () => import("@/view/record/UploadDocuments.vue"),
          meta: {
            userAuth: true,
            keepAlive: true,
          },
        },
        {
          path: "recordDetail",
          name: "recordDetail",
          component: () => import("@/view/record/RecordDetail.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "paySettings",
          component: () => import("@/view/paySettings/PaySettings.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "report",
          component: () => import("@/view/report/Report.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "urgentClose",
          component: () => import("@/view/urgentClose/UrgentClose.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "urgentRecord",
          component: () => import("@/view/urgentClose/UrgentRecord.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "messageCenter",
          component: () => import("@/view/messageCenter/MessageCenter.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "messageDetail",
          component: () => import("@/view/messageCenter/MessageDetail.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "external",
          component: () => import("@/view/Iframe/External.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "tickData",
          component: () => import("@/view/tickData/TickData.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "platformTransfer",
          component: () =>
            import("@/view/platformTransfer/PlatformTransfer.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "platformTransferConfirm",
          component: () =>
            import("@/view/platformTransfer/PlatformTransferConfirm.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "platformTransferResult",
          component: () =>
            import("@/view/platformTransfer/PlatformTransferResult.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "addMT5CheckPassword",
          component: () => import("@/view/addMT5/AddMT5CheckPassword.vue"),
          meta: {
            userAuth: true,
          },
        },
      ],
    },
  ],
});

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

router.beforeEach((to, from, next) => {
  if (from.name == "recordDetail" && to.name == "record") {
    store.dispatch("setKeepAlive", 1);
  } else store.dispatch("setKeepAlive", 0);
  if (to.query.pageType) store.dispatch("setPageType", to.query.pageType);
  if (to.query.appVerName) store.dispatch("setVersion", to.query.appVerName);
  if (to.query.pageType == "app") {
    if (to.query.sourceType == "old") {
      store.dispatch("setSourceType", to.query.sourceType);
      if (to.query.token) {
        next({
          path: "/token",
          query: { url: to.path, loginToken: to.query.token, query: to.query },
        });
        store.dispatch("setToken", to.query.token);
      }
      // 访问主页但未登录
      else if (to.meta.userAuth && !store.state.user.loginname) {
        next({ path: "/login" });
      }
      // 访问登录页但已登录过
      else if (
        (to.fullPath.startsWith("/Login") ||
          to.fullPath.startsWith("/login")) &&
        store.state.user.loginname
      ) {
        next({ path: "/home" });
      }
      next();
    } else {
      if (to.query.accountNo) {
        if (
          !localStorage.getItem("customerNumber") ||
          localStorage.getItem("customerNumber") == null ||
          localStorage.getItem("customerNumber") == "" ||
          typeof localStorage.getItem("customerNumber") == "undefined"
        ) {
          store.dispatch("setCustomerNumber", to.query.accountNo);
        } else if (
          JSON.parse(localStorage.getItem("customerNumber")) !=
          to.query.accountNo
        ) {
          localStorage.clear();
          Cookie.remove("tokenCookie");
          Cookie.remove("m-userCenter");
        }
      }
      if (
        !Cookie.get("tokenCookie") ||
        Cookie.get("tokenCookie") == null ||
        Cookie.get("tokenCookie") == "" ||
        typeof Cookie.get("tokenCookie") == "undefined" ||
        Cookie.get("tokenCookie") == "{}"
      ) {
        if (to.query.token) {
          next({
            path: "/token",
            query: {
              url: to.path,
              loginToken: to.query.token,
              query: to.query,
            },
          });
          store.dispatch("setToken", to.query.token);
          store.dispatch("setTokenCookie", to.query.token);
        }
      } else if (Cookie.get("tokenCookie")) {
        next({
          path: "/token",
          query: {
            url: to.path,
            loginToken: JSON.parse(Cookie.get("tokenCookie")),
            query: to.query,
          },
        });
        store.dispatch("setToken", JSON.parse(Cookie.get("tokenCookie")));
      }
      // 访问主页但未登录
      else if (to.meta.userAuth && !store.state.user.loginname) {
        next({ path: "/login" });
      }
      // 访问登录页但已登录过
      else if (
        (to.fullPath.startsWith("/Login") ||
          to.fullPath.startsWith("/login")) &&
        store.state.user.loginname
      ) {
        next({ path: "/home" });
      }
      next();
    }
  } else {
    if (to.query.token) {
      next({
        path: "/token",
        query: { url: to.path, loginToken: to.query.token, query: to.query },
      });
      store.dispatch("setToken", to.query.token);
    }
    // 访问主页但未登录
    else if (to.meta.userAuth && !store.state.user.loginname) {
      next({ path: "/login" });
    }
    // 访问登录页但已登录过
    else if (
      (to.fullPath.startsWith("/Login") || to.fullPath.startsWith("/login")) &&
      store.state.user.loginname
    ) {
      next({ path: "/home" });
    }
    next();
  }
});

router.afterEach((to) => {
  checkEnableMT5(to.query);
});

export default router;
